import utils from '@eitje/utils'
import './index.less'
import {Text} from '~/components'

// otherProps are needed for Ark to pass the Ark DatePicker.Trigger props
export const DatePickerFieldTrigger = ({children, isPlaceholderShown, ...otherProps}) => {
	return (
		<button
			type="button"
			className="date-picker-field-trigger"
			{...otherProps}
			onClick={e => {
				// Prevent buildField field wrapper from programmatically clicking on the trigger (causing double-clicks)
				e.stopPropagation()
				// Proceed with Ark's trigger logic
				otherProps?.onClick(e)
			}}
		>
			<Text className={utils.makeCns('form-field-value-label', isPlaceholderShown && 'form-field-value-placeholder')}>{children}</Text>
		</button>
	)
}
